// Written in this round about way for babel-transform-imports
import matchPath from "react-router/es/matchPath";

export default matchPath;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/matchPath.js
// module id = 76
// module chunks = 0